import React from "react"
import { graphql } from 'gatsby'
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import Hero from "../components/Hero"
import Logo from "../components/Logo"
import Block from "../components/Content/Block"
import videosrc from "../images/loop-alemana.mp4"
class IndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <Seo title=" Salud, ciencia y tecnología para deportistas - Especiales La Tercera - Presentado por Alemana Sport" keywords={[`clínica alemana`, `deporte`, `deportistas`, `clínica alemana sport`]} />

        <Hero videosrc={videosrc}>
          <Logo width="200" height="300" />
        </Hero>

        {this.props.data.allWordpressPost.edges.map(({ node }) =>
          (
            <Block key={node.id} to={`/${node.slug}`} title={node.title} image={node.featured_media} excerpt={node.excerpt} raw={node.raw} video={node.acf.video_featured} titulo={node.acf.titulo} subtitulo={node.acf.subtitulo} seemore />
          ))
        }
      </Layout>
    )
  }
}

export const pageQuery = graphql`
  query getByTag($tagslug: String = "especial-clinica-alemana") {
    allWordpressPost(
      filter: {
        tags: {
          elemMatch: {
            slug: {
              eq: $tagslug
            }
          }
        }
      },
      sort: {
        fields: date
        order: DESC
      }
    ) {
      edges {
        node {
          id
          slug
          title
          excerpt
          raw
          acf{
            titulo
            subtitulo
            video_featured
          }
          featured_media{
            localFile {
              childImageSharp {
                fluid(
                  maxWidth: 1200,
                  quality: 90,
                ){
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`

export default IndexPage
